module.exports = __webpack_public_path__ + "img/coupon_8.e279154b.png";